import React from "react";
import styled from "styled-components";
import work1 from "../images/work1.png";
import work2 from "../images/work2.png";
import { useTranslation } from "react-i18next";

const Wrapper = styled.div`
  background-color: #D0C8B9;
  background-color: white;
  background-color: #f3f2eaff;
  padding: 35px 15px 50px;

  @media (min-width: 1024px) {
    flex-direction: row;
    padding: 30px 60px 100px;
  }
`;

const Works = styled.div`
  width: 100%;
  padding-bottom: 100px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-basis: 0;

  @media (min-width: 1024px) {
  flex-direction: row;
  }

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    cursor: pointer;
    overflow: hidden;

    @media (min-width: 1024px) {
      width: 50%;
    }
  }

  a:before, a:after {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    transition: all 0.3s ease-in;
  }

  a:before {
    background-color: #3d3d3d;
    opacity: 0.5;
    z-index: 1;
  }

  a:after {
    background-color: #6A8CAF;
    opacity: 0.2;
    z-index: 2;
  }

  a:hover img {
    transform: scale(1.05);
  }

  a:hover p {
    color: white;
    transform: translateY(-5px);
    opacity: 1;
  }

  a:hover:before {
    opacity: 0.4;
  }

  a:hover:after {
    opacity: 0.7;
  }

  img {
    filter: grayscale(100%);
    -webkit-filter: grayscale(100%);
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: all 0.8s ease-out;
  }

  p {
    color: white;
    opacity: 0;
    position: absolute;
    text-align: center;
    font-family: Lato;
    z-index:3;
    font-size: 18px;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    transition: all 0.6s ease;
  }
`;


const Collaboration = styled.div`
  font-size: 17px;
  text-align: center;

  p {
    text-transform: uppercase;
    letter-spacing: 1px;
  }
`;

const Title = styled.h2`
  -webkit-text-size-adjust: 100%;
  -webkit-font-smoothing: subpixel-antialiased;
  text-transform: uppercase;
  letter-spacing: 6px;
  margin: 20px 0 70px;
`;

const List = styled.ul`
  list-style: none;
  padding: 20px 0 0;
  margin: 0;
  text-align: center;
`;

const Item = styled.li`
  margin-bottom: 15px;

  a {
    font-family: Lato;
    text-decoration: none;
    text-transform: uppercase;
    color: #3D3D3D;
    transition: background-color 0.3s ease-in;
  }
  a:hover {
    background-color: #6A8CAF;
    color: white;
  }
`;


const Header = () => {
  const { t, i18n } = useTranslation();

    const works = [
    { name: "Amsterdam Dance Event", url: "https://www.amsterdam-dance-event.nl/en/" },
    { name: "Awakenings Festival", url: "https://www.awakenings.com/en/" },
    { name: "Best Kept Secret Festival", url: "https://www.bestkeptsecret.nl/" },
    { name: "Boer & Croon", url: "https://boercroon.nl/" },
    { name: "Cepezed", url: "https://www.cepezed.nl/en/" },
    { name: "Change Inc.", url: "https://www.change.inc/"} ,
    { name: "De Bijenkorf", url: "https://www.debijenkorf.nl/" },
    { name: "Eye Filmmuseum", url: "https://www.eyefilm.nl/nl" },
    { name: "Moco Museum", url: "https://mocomuseum.com/" },

  ];
  return (
    <>
      <Wrapper id="work">
        <Title>{t("work")}</Title>
        <Works>
            <a href="https://www.dominiquedorla.re" target="_blank" rel="nofollow noreferrer">
            <p>Dominique Dorla</p>
            <img src={work1} alt='Dominique Dorla' />
            </a>

                   <a href="https://www.lakazartson.re" target="_blank" rel="nofollow noreferrer">
    <p>La Kaz Art & Son</p>
            <img src={work2} alt='La Kaz Art & Son' />

         </a>
        </Works>

<Collaboration>
      
          <p>{t("collaborations")}</p>
          <List>
        {works.map((work) => (
          <Item key={work.name}>
            <a href={work.url} target="_blank" rel="nofollow noreferrer">
               {work.name}
            </a>
          </Item>
        ))}
      </List>
      </Collaboration>

      </Wrapper>
    </>
  );
};

export default Header;
